<template>
  <v-form>
    <v-container>
      <v-row>
        <v-col lg="6" offset-lg="3" v-if="loading">
          <Loading></Loading>
        </v-col>
        <v-col lg="6" offset-lg="3" v-else-if="!loading" dense>
          <v-row>
            <h2 class="main--text"> Personal info </h2>
          </v-row>
          <br/>
          <v-row dense>
            <v-col>
              <v-text-field
                filled
                disabled
                label="First name"
                v-model="user.firstName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                filled
                disabled
                label="Last name"
                v-model="user.lastName">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                filled
                disabled
                label="Email"
                v-model="user.emailAddress">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                filled
                label="Mobile"
                v-model="user.mobile">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                filled
                disabled
                label="Company name"
                v-model="user.companyName">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                filled
                disabled
                label="VAT Number"
                v-model="user.vatNo">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn 
              v-on:click="updateUser" 
              color="primary"
              block
              rounded
              height="50"
              >Update</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  name: "UserProfile",
  components: { Loading },
  data() {
    return {
      loading: false,
      userId: 'undefined',
      userRef: {},
      user: {}
    }
  },
  computed: {
    getUser(){
      return this.$store.getters['auth/getUser'];
    }
  },
  methods: {
    async updateUser() {
      this.loading = true;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        'firstName': this.user.firstName,
        'lastName': this.user.lastName,
        'companyName': this.user.companyName,
        'emailAddress': this.user.emailAddress,
        'mobile': this.user.mobile,
        'sageId': this.user.sageId,
        'userId': this.user.id
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      await fetch("https://us-central1-wrapp-waste.cloudfunctions.net/sageCustomer", requestOptions)
      .then(async () => {
        await this.$store.dispatch('auth/registerSageUser', this.user); 
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
        alert(error)
      });
    }
  },
  async mounted () {
    this.user = this.getUser;
  }
}
</script>

<style scoped>

</style>